export default function (path) {
  // const authPaths = ['personal','publish-step','publish-msg']
  const authPaths = ['personal','publish-step']
  return authPaths.some(item => path.includes(item))
}